// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".professional_page_owner_modal-module__discreet--R0SGT{color:#616161}@media screen and (max-width: 48em){.professional_page_owner_modal-module__discreet--R0SGT{text-align:center}}.professional_page_owner_modal-module__link--GC7ho{color:#616161;cursor:pointer;text-decoration:underline;font-weight:400;font-size:14px;line-height:21px;letter-spacing:0}\n", ""]);
// Exports
exports.locals = {
	"discreet": "professional_page_owner_modal-module__discreet--R0SGT",
	"link": "professional_page_owner_modal-module__link--GC7ho"
};
module.exports = exports;
